import React from 'react';
import {Box, Typography} from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';

export const HeaderAnalysisInfoBanner: React.FC = () => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'flex-start',
      gap: 1.5,
      p: 1.5,
      bgcolor: '#EEF5FB',
      borderRadius: 1,
      borderLeft: '4px solid #2F6FAE',
      margin: '16px 16px 8px',
      width: '50%',
    }}
  >
    <ErrorIcon
      data-testid="error-icon"
      sx={{
        color: '#2F6FAE',
        fontSize: 18,
        margin: 'auto',
      }}
    />

    <Typography
      variant="body2"
      sx={{
        color: '#355F8A',
        fontSize: 14,
        lineHeight: 1.5,
        fontWeight: 500,
      }}
    >
      When <strong>multiple rules</strong> match an email, only the{' '}
      <strong>highest-scoring rule</strong> is compared against the base score
      (from automatic security checks). The higher of the two becomes the{' '}
      <strong>final threat score</strong>.
    </Typography>
  </Box>
);
